import { Component, OnInit } from '@angular/core';
import { orderBy } from 'lodash';

import { StuckProgramRow, StuckProgramsService, VendorAckState } from '../shared/service';

const HIDE_THRESHOLD_DAYS = 7;
const ALLOWED_VENDORS = ['SFC', 'SRMAX'];

@Component({
  selector: 'stuck-programs',
  templateUrl: './stuck-programs.component.html',
  styleUrls: ['./stuck-programs.component.scss'],
})
export class StuckProgramsComponent implements OnInit {
  loading = true;
  rows: StuckProgramRow[] = [];
  hideRecent = true;
  error: string = null;
  actionError: { [program: string]: string } = {};
  actionPending: { [key: string]: boolean } = {};

  readonly hideThreshold = HIDE_THRESHOLD_DAYS;
  readonly vendors = ALLOWED_VENDORS;

  constructor(private stuckProgramsService: StuckProgramsService) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    this.error = null;
    this.stuckProgramsService
      .list()
      .then((rows: StuckProgramRow[]) => {
        this.rows = orderBy(rows || [], ['ageDays'], ['desc']);
        this.loading = false;
      })
      .catch((err) => {
        this.error = (err && err.message) || 'Failed to load stuck programs';
        this.loading = false;
      });
  }

  get visibleRows(): StuckProgramRow[] {
    if (!this.hideRecent) {
      return this.rows;
    }
    return this.rows.filter((r) => (r.ageDays || 0) >= HIDE_THRESHOLD_DAYS);
  }

  vendorState(row: StuckProgramRow, code: string): VendorAckState | null {
    if (!row.vendors) {
      return null;
    }
    return row.vendors.find((v) => v.code === code) || null;
  }

  actionKey(program: string, vendor: string) {
    return `${program}::${vendor}`;
  }

  isPending(program: string, vendor: string) {
    return !!this.actionPending[this.actionKey(program, vendor)];
  }

  fakeAck(row: StuckProgramRow, vendor: string) {
    const confirmMsg = `Mark ${vendor} as acknowledged for program ${row.program}? This is recorded in the audit log.`;
    if (!confirm(confirmMsg)) {
      return;
    }

    const key = this.actionKey(row.program, vendor);
    this.actionPending[key] = true;
    this.actionError[row.program] = null;

    this.stuckProgramsService
      .fakeAck(row.program, vendor)
      .then(() => {
        this.actionPending[key] = false;
        this.load();
      })
      .catch((err) => {
        this.actionPending[key] = false;
        this.actionError[row.program] = (err && err.message) || 'Failed to mark vendor acked';
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/stuck-programs/stuck-programs.component.ts